const MIN_VALUE = Number.MIN_SAFE_INTEGER;
const MAX_VALUE = Number.MAX_SAFE_INTEGER;

export const validateNumber = value => !isNaN(value);

export const isNumberInRange = (value, minValue = MIN_VALUE, maxValue = MAX_VALUE) => {
    if (!value) {
        return false;
    }
    const floatValue = parseFloat(value);
    return floatValue <= maxValue && floatValue >= minValue;
};

export const createCounterObject = arrayOfKeys =>
    arrayOfKeys.reduce((counterObj, currValue) => {
        counterObj[currValue] = 0;
        return counterObj;
    }, {});

/**
 * Format a number with locale-appropriate thousands separators.
 * @param {number|string} value
 * @param {string} [locale='en']
 * @param {Intl.NumberFormatOptions} [options]
 * @returns {string}
 */
export const formatNumber = (value, locale = 'en', options) => {
    const float = parseFloat(`${value}`);
    if (Number.isNaN(float) || !Number.isFinite(float)) {
        return `${value}`;
    }
    return new Intl.NumberFormat(locale, options).format(float);
};

/**
 * Format a decimal number with locale-appropriate separators.
 * @param {number|string} value
 * @param {string} [locale='en']
 * @param {number} [decimals=2]
 * @returns {string}
 */
export const formatDecimal = (value, locale = 'en', decimals = 2) => {
    return formatNumber(value, locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};

/**
 * Format a percentage value with locale-appropriate separators.
 * Input is the human-readable percentage (e.g. 45.67 for "45.67%").
 * @param {number} value - e.g. 45.67
 * @param {string} [locale='en']
 * @param {number} [decimals=0]
 * @returns {string}
 */
export const formatPercent = (value, locale = 'en', decimals = 0) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return `${value}`;
    }
    return `${formatDecimal(value, locale, decimals)}%`;
};
